import { z } from "zod";
var PRODUCT_NAME = /* @__PURE__ */ ((PRODUCT_NAME2) => {
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_QUARTERLY"] = "membership_19_99_eur_quarterly";
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_ANNUALLY"] = "membership_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_SINGLE"] = "membership_19_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_9_99_EUR_ANNUALLY"] = "membership_9_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_BIDROOM_19_99_EUR_ANNUALLY"] = "membership_bidroom_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_49_99_EUR_ANNUALLY"] = "membership_complete_49_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_49_99_EUR_SINGLE"] = "membership_complete_49_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_64_99_EUR_ANNUALLY"] = "membership_complete_64_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_19_99_EUR_ANNUALLY"] = "membership_essential_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_19_99_EUR_SINGLE"] = "membership_essential_19_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_24_99_EUR_SINGLE"] = "membership_essential_24_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_22_49_EUR_SINGLE"] = "membership_essential_22_49_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_24_99_EUR_ANNUALLY"] = "membership_essential_24_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_TELEMEDICO_19_99_EUR_ANNUALLY"] = "membership_telemedico_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_9_99_EUR_SINGLE"] = "membership_9_99";
  PRODUCT_NAME2["MEMBERSHIP_FREE"] = "membership_free";
  PRODUCT_NAME2["MEMBERSHIP_FREEMIUM"] = "membership_freemium";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_INTERNAL"] = "membership_complete_internal";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_EXTERNAL"] = "membership_complete_external";
  PRODUCT_NAME2["AIRHELP_SMART_SINGLE"] = "airhelp_smart_single";
  PRODUCT_NAME2["AIRHELP_SMART_ANNUALLY"] = "airhelp_smart_annually";
  PRODUCT_NAME2["AIRHELP_PRO_ANNUALLY"] = "airhelp_pro_annually";
  PRODUCT_NAME2["TRIP"] = "trip";
  PRODUCT_NAME2["TRIP_ESSENTIAL"] = "trip_essential";
  PRODUCT_NAME2["TRIP_COMPLETE"] = "trip_complete";
  PRODUCT_NAME2["KIWI_AHPLUS"] = "kiwi_ahplus";
  PRODUCT_NAME2["KIWI_AIR_LUGGAGE"] = "kiwi_air_luggage";
  PRODUCT_NAME2["KIWI_AHPLUS_AIR_LUGGAGE"] = "kiwi_ahplus_air_luggage";
  PRODUCT_NAME2["AGODA_AHPLUS_AIR_PAYOUT"] = "agoda_ahplus_air_payout";
  PRODUCT_NAME2["UPGRADE_TO_TRIP_COMPLETE"] = "upgrade_to_trip_complete";
  PRODUCT_NAME2["TEST_MEMBERSHIP"] = "test_membership";
  return PRODUCT_NAME2;
})(PRODUCT_NAME || {});
var PAYMENT_FREQUENCY = /* @__PURE__ */ ((PAYMENT_FREQUENCY2) => {
  PAYMENT_FREQUENCY2["NONE"] = "none";
  PAYMENT_FREQUENCY2["SINGLE"] = "single";
  PAYMENT_FREQUENCY2["QUARTERLY"] = "quarterly";
  PAYMENT_FREQUENCY2["ANNUALLY"] = "annually";
  return PAYMENT_FREQUENCY2;
})(PAYMENT_FREQUENCY || {});
const SUPPORTED_CURRENCY_CODES = [
  "EUR",
  "USD",
  "BRL",
  "PLN",
  "SEK",
  "CHF",
  "GBP",
  "RON"
];
var PRODUCT_PERK = /* @__PURE__ */ ((PRODUCT_PERK2) => {
  PRODUCT_PERK2["ESIM"] = "Esim";
  PRODUCT_PERK2["AIR_PAYOUT"] = "AirPayout";
  PRODUCT_PERK2["AIR_LUGGAGE"] = "AirLuggage";
  PRODUCT_PERK2["AIRPORT_TRANSFER"] = "AirportTransfer";
  PRODUCT_PERK2["LOUNGE_ACCESS"] = "LoungeAccess";
  PRODUCT_PERK2["CAR_RENTAL"] = "CarRental";
  PRODUCT_PERK2["FLIGHT_NOTIFICATION"] = "FlightNotification";
  PRODUCT_PERK2["JOURNEY_LOUNGE_ACCESS"] = "JourneyLoungeAccess";
  return PRODUCT_PERK2;
})(PRODUCT_PERK || {});
const featureFlagSchema = z.object({
  key: z.string(),
  state: z.enum(["on", "off"])
});
const offerSchema = z.object({
  id: z.number().nullable(),
  uuid: z.string().nullable(),
  currency: z.string().nullable().optional(),
  // Marked native enum to document the type, it is relaxed to string because offers may change dynamically
  name: z.nativeEnum(PRODUCT_NAME).or(z.string()),
  displayName: z.string().optional(),
  paymentFrequency: z.nativeEnum(PAYMENT_FREQUENCY).nullable(),
  prices: z.record(
    z.enum(SUPPORTED_CURRENCY_CODES),
    z.object({
      code: z.enum(SUPPORTED_CURRENCY_CODES),
      symbol: z.string().optional(),
      label: z.string().optional(),
      price: z.coerce.number()
    })
  ),
  productPerks: z.array(
    z.object({
      config: z.record(z.string(), z.any()),
      credits: z.number(),
      unlimited: z.boolean(),
      // Marked native enum to document the type, it is relaxed to string because offers may change dynamically
      type: z.nativeEnum(PRODUCT_PERK).or(z.string())
    })
  ).nullable().optional().default([])
});
const loungeSchema = z.object({
  additional: z.string(),
  airportCode: z.string(),
  airportName: z.string(),
  city: z.string(),
  conditions: z.string(),
  country: z.string(),
  countryCode: z.string(),
  images: z.array(
    z.object({
      url: z.string().url(),
      width: z.number(),
      height: z.number(),
      altText: z.string(),
      contentType: z.string(),
      lastModified: z.string()
    })
  ),
  location: z.string(),
  loungeCode: z.string(),
  loungeName: z.string(),
  openingHours: z.string(),
  terminal: z.string(),
  terminalCode: z.string()
});
const fetchOffersResponseSchema = z.object({
  canBuyPlus: z.boolean(),
  offers: z.array(offerSchema),
  renewOffers: z.array(offerSchema)
});
function fetchOffers({ client }) {
  return client.get(`/api/v2/offers`).valid(fetchOffersResponseSchema);
}
const fetchFeatureFlagsResponseSchema = z.object({
  features: z.array(featureFlagSchema)
}).transform((data) => {
  const transformedResponse = {};
  data.features.forEach((feature) => {
    transformedResponse[feature.key] = feature.state === "on";
  });
  return transformedResponse;
});
function fetchFeatureFlags({ client }) {
  return client.get(`/api/v2/feature_flags`).valid(fetchFeatureFlagsResponseSchema);
}
const fetchLoungesRequestSchema = z.object({
  airportCode: z.string()
});
const fetchLoungesResponseSchema = z.array(loungeSchema);
function fetchLounges({
  client,
  params
}) {
  const { airportCode } = fetchLoungesRequestSchema.parse(params);
  return client.get(`/api/v2/lounges/${airportCode}`).valid(fetchLoungesResponseSchema);
}
export {
  PRODUCT_NAME as P,
  SUPPORTED_CURRENCY_CODES as S,
  fetchOffers as a,
  fetchFeatureFlagsResponseSchema as b,
  fetchFeatureFlags as c,
  fetchLoungesRequestSchema as d,
  fetchLoungesResponseSchema as e,
  fetchOffersResponseSchema as f,
  fetchLounges as g,
  featureFlagSchema as h,
  PAYMENT_FREQUENCY as i,
  PRODUCT_PERK as j,
  loungeSchema as l,
  offerSchema as o
};
//# sourceMappingURL=fetch-lounges-DBfdg699.js.map
